export default "__VITE_ASSET__DR5s6096__"